const Spinner = {
  template: `
    <div :style="theme.container">
      <router-view></router-view>
    </div>
  `,
  show: obj => {
    return new Promise((resolve, reject) => {
      // console.log(process.env.NODE_ENV)
      if (process.env.NODE_ENV && process.env.NODE_ENV !== "development?") {
        require("../resources/spinner.css")
      }

      const spinner = document.createElement("div")
      spinner.id = "redpost-css-spinner-container"
      const div = document.createElement("div")
      div.id = "redpost-css-spinner"
      div.textContent = `処理中`
      spinner.appendChild(div)

      document.body.appendChild(spinner)
      document.body.style.cursor = "wait"
      resolve(obj)
    })
  },
  hide: obj => {
    return new Promise((resolve, reject) => {
      const elm = document.querySelector("#redpost-css-spinner-container")
      if (elm && elm.parentNode) {
        elm.parentNode.removeChild(elm)
      }
      document.body.style.cursor = "default"

      resolve(obj)
    })
  }
}
export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner.js